// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#inbox{width:258px;background-color:#f8fafb;-webkit-box-shadow:1px 0 #cfd8dc;box-shadow:1px 0 #cfd8dc;z-index:1000}", ""]);
// Exports
module.exports = exports;
